export default {
  getEvents(state) {
    return state.events;
  },
};
